angular.module('iw.frontyard.signup')
    .directive('iwCurrencyInput', function ($filter,
                                            SignupLendingAPIHelper) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, element, attrs, ngModel) {
                var minCurrencyValue = parseFloat(attrs.minCurrencyValue);
                var maxCurrencyValue = parseFloat(attrs.maxCurrencyValue);

                ngModel.$parsers.unshift(parseAsFiniteNumber);
                ngModel.$parsers.unshift(parse);
                ngModel.$validators.validCurrency = isValidCurrency;
                ngModel.$render = renderCurrency;


                function isValidCurrency(modelValue, viewValue) {
                    return modelValue >= minCurrencyValue
                        && modelValue <= maxCurrencyValue;
                }

                function renderCurrency() {
                    var clean = parse(ngModel.$viewValue, true);

                    if (angular.isUndefined(clean)) {
                        return;
                    }

                    var currencyValue = $filter('number')(parseFloat(clean));
                    element.val(currencyValue);
                }

                function parse(viewValue, noRender) {
                    if (!viewValue) {
                        return viewValue;
                    }

                    var clean = SignupLendingAPIHelper.replaceNonNumericCharacters(viewValue);

                    if (!noRender) {
                        ngModel.$render();
                    }

                    return clean;
                }

                function parseAsFiniteNumber(viewValue) {
                    var numberValue = parseFloat(viewValue);
                    if (_.isNumber(numberValue) && _.isFinite(numberValue)) {
                        return numberValue;
                    }

                    return null;
                }
            }
        };
    });
